import { Table, TableBody, TableContainer } from '@mui/material'
import { SelectorItem } from '../UserOrGroupSelector'
import SharedWithItemsRow from './SharedWithItemsRow'
import OwnerRow from '../OwnerRow'
import { Users } from 'features/account/types'

// Aux
function SharedWithItemsTable({
  items,
  onResend,
  onRevoke,
  onlyGroups,
  mapOwner,
  disabled
}: {
  items: SelectorItem[]
  onResend?: (item: SelectorItem, action?: 'resend' | 'revoke') => void
  onRevoke: (item: SelectorItem, action?: 'resend' | 'revoke') => void
  onlyGroups?: boolean
  mapOwner?: Users | null
  disabled?: boolean
}) {
  return (
    <TableContainer>
      <Table aria-label="shared table">
        <TableBody>
          {items.map((row: SelectorItem) => (
            <SharedWithItemsRow
              key={row.id}
              item={row}
              onResend={onResend}
              onRevoke={onRevoke}
              hideRole={onlyGroups}
              hideActions={disabled}
            />
          ))}
          {!onlyGroups && mapOwner && <OwnerRow owner={mapOwner} hideActions={disabled} />}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SharedWithItemsTable
